<template>
  <section class="get-quote mt-15">
    <v-container class="mx-auto">
      <h2 class="get-quote-title">{{ quoteCard.title }}</h2>
      <p class="all-quote mt-2">
        {{ quoteCard.description }}
      </p>
      <v-row class="mt-10">
        <v-col
          cols="12"
          sm="6"
          lg="3"
          v-for="c in quoteCard.content"
          :key="c.id"
        >
          <v-card height="317px" class="hover-card">
            <v-list-item>
              <v-list-item-content>
                <v-icon class="card-icon" x-large>
                  {{ c.icon }}
                </v-icon>
                <p class="card-title">
                  {{ c.title }}
                </p>
                <p class="card-description">
                  {{ c.desc }}
                </p>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  props: {
    quoteCard: {
      type: Object,
      require: true
    }
  },
  data () {
    return {}
  }
}
</script>
